import React from 'react';
import {getServerTexts} from '../texts';
import {MultiCompanyDialog} from './MultiCompaniesDialog';

const multiCompDlgRef: React.RefObject<MultiCompanyDialog> = React.createRef();

export async function renderMultiCompDialog(root) {
    await getServerTexts();

    root.render(<MultiCompanyDialog ref={multiCompDlgRef} />);

    return multiCompDlgRef;
}
